import { CSSProperties, FC, useContext } from "react";
import { AppContext } from "../../../App";
import CopyButton from "../../../assets/copyButton.svg";
import "./TextWithCopy.css";
import Tooltip from "../../UiLib/CustomTooltip/CustomTooltip";

interface ITextWithCopyProps {
    text?: string;
    className?: string;
    style?: CSSProperties;
}

const TextWithCopy: FC<ITextWithCopyProps> = ({ text, className, style }) => {
    const { showToast } = useContext(AppContext);

    const copyToBuffer = (text: string) => {
        navigator.clipboard.writeText(text);
        showToast("Скопировано в буфер обмена");
    };

    

    return (
        <div className={className} style={style}>
            <div className="text-with-copy-container">
                <Tooltip text={text ?? ""} placement="bottom">
                    <div className="text">{text}</div>
                </Tooltip>
                <Tooltip text="Скопировать" placement="bottom">
                    <img className="img" alt="copy-button" onClick={() => copyToBuffer(text ?? "")} src={CopyButton} />
                </Tooltip>
            </div>
        </div>
    );
};

export default TextWithCopy;
